import type { AnalyticsEventPayload } from '@atlaskit/analytics-next/AnalyticsEvent';

import { logger } from '../../../common/utils/logger';
import type { ConversationStarter } from './conversation-starters';

export const onConvoStarterClick = (props: {
	starter: ConversationStarter;
	analyticsAttributes: any;
	starterIndex: number;
}): AnalyticsEventPayload => {
	const { starter: starterText, isSummarize, isShowMore, isShowLess } = props.starter;
	try {
		return {
			action: 'clicked',
			actionSubject: 'aiConvoStarter',
			eventType: 'ui',
			attributes: {
				...props.analyticsAttributes,
				starterIndex: props.starterIndex,
				isSummarize,
				isShowMore,
				isShowLess,
			},
			nonPrivacySafeAttributes: {
				starter: starterText,
			},
		};
	} catch (error) {
		logger.error({
			feature: 'sain-text-answer',
			element: 'followup-buttons',
			operation: 'build-analytics',
			category: 'invariant',
			telemetryOnly: true,
			error,
			functionName: 'onConversationStarterClick',
		});
		return {};
	}
};
